<template>
  <div>
    <section class="footerlay">
      <div class="footer-content">
        <div class="mothers11lay">

          <!-- Column 1: Brand, Socials & CFIA Badge -->
          <div class="mother11lay">
            <div class="mother-number11lay"><b><span class="span2lay">SwyChr</span></b></div>
            
            <div class="mother-pip115lay">
              <p class="showlay">Your all-in one digital finance Companion.<br> 
              Fast, Secure, Borderless Finance.</p>
              
              <!-- Social Icons -->
              <div class="sgrouplay">
                <a href="https://web.facebook.com/swychrglobal" target="_blank" rel="noopener"><i class="fab fa-facebook icon-fblay"></i></a>
                <a href="https://www.linkedin.com/company/swychrglobal/?viewAsMember=true" target="_blank" rel="noopener"><i class="fab fa-linkedin icon-fblay"></i></a>  
                <a href="https://x.com/swychrglobal?mx=2" target="_blank" rel="noopener"><i class="fas fa-times icon-fblay"></i></a> 
                <a href="https://www.instagram.com/swychrglobal" target="_blank" rel="noopener"><i class="fab fa-instagram icon-fblay"></i></a> 
              </div>

              <!-- CFIA Membership Badge Section -->
              <div class="cfia-badge-container">
                <a href="https://cmrfintech.com" target="_blank" rel="noopener" title="Cameroon Fintech Association">
                  <img src="@/assets/images/cfia-corporate-badge-white.png" 
                       alt="Cameroon Fintech Association Corporate Member" 
                       class="cfia-badge-img">
                </a>
              </div>
            </div>
          </div>

          <!-- Column 2: Quick Links -->
          <div class="mother11lay">
            <div class="mother-number11lay"><b><span class="span1lay">Quick Links</span></b></div>
            <div class="mother-pip11lay">
              <a href="#" target="_blank">Personal</a><br><br>
              <a href="#" target="_blank">Business</a><br><br>
              <a href="#" target="_blank">Company</a><br><br>
              <a href="About" target="_blank">About Us</a><br><br>
              <a href="Sales" target="_blank">Contact Us</a><br><br>
              
              <router-link to="/download" class="footer-download-highlight">
                Download
              </router-link>
            </div>
          </div>

          <!-- Column 3: Product -->
          <div class="mother11lay">
            <div class="mother-number11lay"><b><span class="span1lay">Product</span></b></div>
            <div class="mother-pip1lay">
              <a href="" target="_blank">Payments</a><br><br>
              <a href="" target="_blank">Accounts</a><br><br>
              <a href="" target="_blank">Virtual & Physical Cards</a><br><br>
              <a href="" target="_blank">Business</a><br><br>
              <a href="" target="_blank">Currency Exchange</a><br><br>
            </div>
          </div>

          <!-- Column 4: Business -->
          <div class="mother11lay">
            <div class="mother-number11lay"><span class="span1lay">Business</span></div>
            <div class="mother-pip11lay">
              <a href="" target="_blank">Invoicing</a><br><br>
              <a href="" target="_blank">Payroll</a><br><br>
              <a href="" target="_blank">Bulk Transfers</a><br><br>
              <a href="" target="_blank">Merchant Tools</a><br><br>
              <a href="" target="_blank">Savings & Wallets</a><br>
            </div>
          </div>

          <!-- Column 5: Company -->
          <div class="mother11lay">
            <div class="mother-number11lay"><b><span class="span1lay">Company</span></b></div>
            <div class="mother-pip11lay">
              <a href="Gallery" target="_blank">Gallery</a><br><br>
              <a href="" target="_blank">Our Mission</a><br><br>
              <a href="" target="_blank">Press & Media</a><br><br>
              <a href="Sales" target="_blank">Contact</a><br><br>
              <a href="https://blog.swychr.com/" target="_blank" rel="noopener">Blog</a><br><br>
            </div>
          </div>

        </div>

        <div class="schoollay"></div>

        <!-- Copyright & Terms -->
        <div class="sergiolay">
          <div class="zoukielay">
            <h3 class="sergiopikanlay"> © 2026 The Swych Group Inc.(TSG)</h3>
            <p class="sergiosonlay">Borderless finance for a digital world.</p>
          </div>

          <div class="chanalay">
            <li class="chana1lay"><a href="Term">| Terms & Conditions</a></li>
            <li class="chana1lay"><a href="Privacy">| Privacy Policy</a></li>
          </div>
        </div>

        <!-- Legal Statement -->
        <p class="rufuslay">
          <b>Legal Disclosure & Regulatory Statement</b> <br>
          <b>Corporate Information</b> “Swychr” is the registered trading name of <b>Swychr Technology Africa Limited</b>, its parent company, subsidiaries, and affiliates (collectively, “the Group”).<br> 
          Swychr Technology Africa Limited is a corporation duly registered in the Republic of Cameroon under Registration Number <b>TPPRR/RC/BUA/2022/B/099.</b><br><br>
          
          <b>Nature of Services</b> Swychr Technology Africa Limited operates as a Financial Technology (Fintech) company and is authorized to provide technological infrastructure and decentralized ledger (Blockchain) related services. <b>Swychr is not a bank, a deposit-taking institution, or a licensed financial institution.</b> <br><br>
          
          All financial services, payment processing, and money transmission services offered via the Swychr mobile application, Swychr Connect web platform, and API suites are facilitated through strategic partnerships with licensed financial institutions, regulated payment processors, and compliance partners within their respective jurisdictions. Swychr provides the technological interface and software; the underlying regulated financial services and fund management are executed by our third-party licensed partners.<br><br>
          
          <b>User Acknowledgment</b> By accessing or utilizing Swychr’s applications and API suites, the user acknowledges and agrees that Swychr acts solely as a technology service provider. All transactional services are rendered by third-party licensed entities in accordance with the local regulations governing their specific domains and territories.<br><br>
          
          <b>Intellectual Property</b> The "Swychr" wordmark and logo are protected under trademark registration number <b>134330</b>, granted under the seal of the African Intellectual Property Organization <b>(OAPI)</b>. Swychr Technology Africa Limited reserves all rights regarding its proprietary technology, branding, and intellectual assets. <br><br>
          
          <b>Jurisdiction-Specific Disclosures (Cameroon)</b> Local microfinance and banking services offered within the Republic of Cameroon through the Swychr Pay mobile and web app are provided under a Category 1 Microfinance Institution (Swychr Cooperative Society with Board of Directors – SWYCO-COOP-BOD), operating Financial Cooperative Number <b>26/022/CMR/SW/53/282/CCA/036004/036004000</b><br><br>
          
          <b>Swychr Technology Africa Limited is a member of Cameroon Fintech Association (CFIA)</b><br><br>
          
          © 2026 The Swych Group Inc.(TSG). All rights reserved.
        </p>
      </div>
    </section>
  </div>
</template>


<style scoped>
.footerlay {
           font-family: 'Montserrat', sans-serif;
            margin: 0;
            background: linear-gradient(#29013E,#28013C,#170124);
            color: #fff;
            width: 100%;  
           margin: 0 auto;
        }
           
        
        .mother-number11lay{
          font-size:20px;
          font-weight: bold;
          display: inline-flex;
          align-items: center;
          justify-content: center;
       
        }

        .mother-pip11lay{
          flex: 1;
          text-align: justify;
          align-items: center;
          padding: 10px;
        } 

        .icon-fb{
          width: 24px;
         height: 24px;
         aspect-ratio: 1/1;
        }
        
        .arrow-1{
          color: white;
          width: 24px;
          height: 24px;
          margin-left: 5px;
        }
    
.footerlay a{
text-decoration: none;
color:  #ffffff;
font-family: 'Montserrat', sans-serif;
font-size: 14px;
font-style: normal;
font-weight: 535;
line-height: 120%;
text-align:justify;
}

.footerlay i{
    margin-right: 8px;
        }
        

.span2lay{
  font-size: 25px;
  color: #ffffff;
}

 .mother-pip115lay{ 
  margin-top: 20px !important;   
  line-height: 1.6;             
}
      
  
   
 
  .showlay{
color: #ffffff;
font-family: 'Montserrat', sans-serif;
font-size: 14px;
font-style: normal;
font-weight: 535;
line-height: 120%;
text-align:left;
 }
 
 .span1lay, .span2lay {
  display: block;
  margin-bottom: 25px !important;
}


.mother11lay {
  margin: 1.1rem 0; 
  flex: 1;
}

.footer-content {
  max-width: 1200px; 
  margin: 0 auto;    
  padding: 0 40px;  
}

.mothers11lay{
  width: 100% !important; 
  margin-left: 0 !important;   
  margin-right: 0 !important;
  padding: 0 !important;
  display: flex;
  justify-content: space-between;
  margin-bottom: 60px !important;
}

.sergiolay{
  color: #ffffff !important;
  width: 100% !important; 
  margin-left: 0 !important;   
  margin-right: 0 !important;
  padding: 0 !important;
}

.rufuslay {
  color: #ffffff !important;
  width: 100%;
  margin-top: 30px !important;
  width: 100% !important; 
  margin-left: 0 !important;  
  margin-right: 0 !important;
  padding: 0 !important;
}

.schoollay {
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  width: 100%;
  margin-top: 20px !important;    
  margin-bottom: 50px !important;
}

.span1lay {
  color: #FFF;
  font-size: 17px;
  font-weight: 550;
  display: block;  
  margin-bottom: 15px;
}

.zoukielay{
  margin-right: 0; 
  text-align: left;
  color: #FFFFFF !important;
}

.sgrouplay {
  margin-top: 25px !important;   
}

.sgrouplay a {
  width: 40px; 
  height: 40px;
  background-color: rgba(255, 255, 255, 0.1); 
  border-radius: 50%;
  display: inline-flex !important;
  justify-content: center !important; 
  align-items: center !important;    
  text-decoration: none;
  margin: 0 5px;
  padding: 0 !important; 
}

.sgrouplay i {
  line-height: 1 !important;
  margin: 0 !important;
  font-size: 18px; 
}

.chanalay {
  margin-right: 0;
  display: flex;
  gap: 20px; 
  list-style: none;
  padding: 0;
  color: #FFFFFF !important;
}

.chanalay  a{
  color: #FFFFFF;
}

.zoukielay h3, p{
  color: #FFFFFF;
}

.chana1lay{
  white-space: nowrap;
}

.seam{
margin-top: 20px;
margin-left: 67px;
}

@media only screen and (max-width: 820px) {
  .sergiolay {
    flex-direction: column; 
    align-items: center;
    text-align: center;
    gap: 20px;
  }
  
  .zoukielay {
    text-align: center;
  }
  
  .chanalay {
    justify-content: center;
  }
}

@media only screen and (max-width: 1180px) {
    .mothers11lay {
        flex-wrap: wrap;
        margin-left: 20px;
        justify-content: space-around;
        gap: 20px;
    }

    .mother11lay {
        flex: 1 1 30%; 
        margin-left: 0;
        text-align: left;
    }

    .mother-pip11lay, .mother-pip115lay {
        text-align: left;
    }

    .schoollay {
        width: 95%;
        margin: 20px auto;
    }

    .sergiolay {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding-left: 20px;
        gap: 15px;
    }

    .zoukielay {
        margin-right: 0;
    }

    .chanalay {
        margin-right: 0;
        padding: 0;
    }

    .rufuslay {
        margin-left: 20px;
        width: 90%;
        font-size: 14px;
    }
}

@media only screen and (max-width: 430px) {
    .footerlay {
        padding-bottom: 40px;
    }

    .mothers11lay {
        flex-direction: column; 
        margin-left: 20px;
        gap: 35px;
    }

    .mother11lay {
        width: 100%;
        margin: 0;
    }

    .mother-number11lay{
        justify-content: flex-start;
        margin-bottom: 10px;
    }

    .span1lay, .span2lay {
        margin: 0;
    }

    .mother-pip11lay br, .mother-pip115lay br {
        display: none; 
    }

    .sgrouplay {
        margin-top: 15px;
        display: flex;
        gap: 20px;
    }

    .schoollay{
        width: 90%;
        margin: 30px auto;
    }

    .sergiolay {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
    }

    .chanalay {
        flex-direction: column;
        gap: 10px;
    }

    .chana1lay {
        font-size: 14px;
    }

    .rufuslay {
        margin: 25px 20px 0 20px;
        font-size: 12px;
        line-height: 1.5;
        width: auto;
    }
}


@media only screen and (max-width: 430px) {
  .mothers11lay {
    margin-left: 0 !important;
    padding: 0 1rem;
    display: flex !important;
    flex-direction: column !important; 
    align-items: center !important;
    width: 100%;
    gap: 3rem;
  }


  .mother11lay {
    margin: 0 auto !important;
    padding: 0;
    width: 90%; 
    text-align: center !important; 
  }


  .mother-number1lay {
    display: flex !important;
    justify-content: center !important;
    width: 100%;
    margin-bottom: 0.625rem;
  }

  .span1lay, .span2lay {
    margin: 0 !important;
    font-size: 1.5rem !important;
    line-height: 1.1;
  }


  .sgrouplay {
    margin: 1rem auto 0 auto !important;
    display: flex;
    justify-content: center;
    gap: 1.5rem; 
  }


  .showlay {
    margin: 1.25rem 0;
    text-align: center;
    font-size: 0.9rem;
    line-height: 1.5;
    width: 100%;
    display: block;
    margin-left: 0 !important;
  }

  
  .mother-pip11lay {
    margin: 0 auto !important;
    padding: 0;
    display: flex !important;
    flex-direction: column !important; 
    align-items: center !important;
    gap: 0.75rem; 
    width: 100%;
  }


  .mother-pip11lay a {
    display: block !important;
    width: 100%;
    text-align: center !important;
    padding: 0.5rem 0;
    font-size: 1rem;
  }

  .mother-pip11lay br {
    display: none !important;
  }
}


.footer-download-highlight {
  color: #FFFFFF !important; 
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  transition: transform 0.2s ease, color 0.2s ease;
}

.footer-download-highlight:hover {
  color: #ffffff !important;
  transform: translateX(4px);
}


/* CFIA Badge Specific Styles */
.cfia-badge-container {
  margin-top: 25px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.cfia-badge-img {
  width: 210px; 
  height: auto;
  display: block;
  transition: opacity 0.2s ease-in-out;
}

.cfia-badge-img:hover {
  opacity: 0.85;
}


@media only screen and (max-width: 430px) {
  .cfia-badge-container {
    justify-content: center !important;
    margin-top: 20px;
  }
}
</style>